import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=e55aef7c&scoped=true&"
import script from "./HeaderTabs.vue?vue&type=script&lang=js&"
export * from "./HeaderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55aef7c",
  null
  
)

export default component.exports